<template>
    <el-table
            :data="propsTableData"
            style="width: 100%"
            class="table-wrap income-table-wrap">
        <el-table-column
                prop="makeTime"
                label="日期"
                :formatter="formatUnix"
                show-overflow-tooltip
                align="left">
        </el-table-column>
        <el-table-column
                prop="patName"
                label="患者姓名"
                class="table-column"
                align="center"
                show-overflow-tooltip>
        </el-table-column>
        <el-table-column
                prop="paySubject"
                label="业务名称"
                class="table-column"
                align="center"
                show-overflow-tooltip>
        </el-table-column>
        <el-table-column
                prop="makeFee"
                label="金额"
                align="center"
                class="table-column"
                show-overflow-tooltip>
            <template slot-scope="scope">
                <span v-if="scope.row.makeStatus == 'WAIT_CASHOUT'||scope.row.makeStatus == 'SUCCESS'"><span class="table-status-green">收入</span>{{ parseFloat(scope.row.makeFee/100).toFixed(2) }}元</span>
                <span v-if="scope.row.makeStatus == 'SUCCESS'"> <span class="table-status-red">提现</span>{{ scope.row.makeFee }}元 </span>
            </template>
        </el-table-column>

    </el-table>
</template>
<style>

</style>
<script>
    import { formatUnixTime } from "../../utils/DateFormat.js"
    export default{
        props: ["propsTableData"],
        methods: {
            formatUnix: function(row, column){//格式化时间格式
                if(row.makeTime){
                    return formatUnixTime(row.makeTime, "yyyy.MM.dd HH:mm");
                }
            },
        }
    }
</script>
